import React, {Component} from 'react';
import {Col, Container, Row} from "react-bootstrap";

class Legal extends Component {
    render() {
        return (
            <div className="footer-legal" >
            <div style={{padding: '30px'}}>
                <div>
                    <Row>
                        <Col xs={12} md={6}>
                            <div className="site-copyright"  style={{
                                color: '#FFFFFF',
                                fontSize: '0.8em'
                            }}>
                                © 2021 The Board of Trustees of the University of Illinois <span
                                className="pipe-separator">| </span>
                                <a  style={{
                                    color: '#FFFFFF',
                                }} href="https://www.vpaa.uillinois.edu/resources/web_privacy">Privacy Statement</a>
                            </div>

                        </Col>
                        <Col>
                            <div className="campuses" aria-label="Campuses">
                                <Row>
                                    <Col>
                                        <a  style={{
                                            color: '#FFFFFF',fontSize: '0.8em'
                                        }} href="https://www.uillinois.edu/">University of Illinois System</a>

                                    </Col>
                                    <Col>
                                        <a  style={{
                                            color: '#FFFFFF',fontSize: '0.8em'
                                        }} href="https://illinois.edu/">Urbana-Champaign</a>

                                    </Col>
                                    <Col>
                                        <a style={{
                                            color: '#FFFFFF',fontSize: '0.8em'
                                        }} href="https://www.uis.edu/">Springfield</a>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
            </div>
        );
    }
}

export default Legal;


// WEBPACK FOOTER //
// ./src/components/footers/Legal.js